<div class="feet">
    <a href="./quote-form">Request a free quote today!</a>
    <h3>(319) 540.4778</h3>
    <h3>sean.ats@outlook.com</h3>

</div>
